import { Container, Row, Col } from 'react-bootstrap';

function Layout({ children }){
  return (
      <Container fluid className='layout d-flex flex-column px-2 py-2'>
        <Row className=''>
          <Col className='stories-overlay'>{children}</Col>
        </Row>
      </Container>
  );
}

export default Layout;